/* global SERVER_BASE_URL, ZENDESK_HELP_CENTER_URL */
import React, { Component } from 'react'
import q from 'query-string'
import { notification } from 'antd'
import { DEFAULT_ROUTE } from '@constants/routes'
import { getToken } from '@auth/token-service'

class SSOLogin extends Component {
  componentDidUpdate() {
    const parsed_url = q.parse(this.props.location.search)
    this.proceedZendeskSso(parsed_url)
  }

  proceedZendeskSso = async (parsed_url) => {
    try {
      const brand_id = parsed_url.brand_id
      const locale_id = parsed_url.locale_id
      const return_to = parsed_url.return_to
      if (!brand_id || !locale_id || !return_to) {
        throw new Error('SSO Failed: Missing required parameters')
      }
      const response = await fetch(SERVER_BASE_URL + '/api/sso/zendesk-jwt', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'content-type': 'application/json',
        },
      })
      const data = await response.json()
      if (response.ok) {
        this.submitSsoJwtForm(data.jwt, return_to)
      } else {
        throw new Error(data.error)
      }
    } catch (error) {
      notification.error({ message: error.message })
      this.props.history.push(`/${DEFAULT_ROUTE}`)
    }
  }

  submitSsoJwtForm = (jwt, returnTo) => {
    const ssoForm = document.createElement('form')
    ssoForm.method = 'POST'
    ssoForm.action = `${ZENDESK_HELP_CENTER_URL}/access/jwt?return_to=${encodeURIComponent(returnTo)}`

    const jwtInput = document.createElement('input')
    jwtInput.type = 'hidden'
    jwtInput.name = 'jwt'
    jwtInput.value = jwt
    ssoForm.appendChild(jwtInput)

    document.body.appendChild(ssoForm)
    ssoForm.submit()
  }

  render() {
    return <div></div>
  }
}

export default SSOLogin
